import ApiCall from "./ApiCall";
import { deleteAllCookies } from "./Utils";

const Handler = async ({ method, url, data = {}, headers = {}, formData = false }) => {
    let responseData = {};
    try {
        const response = await ApiCall({ url, method, data, headers, formData });
        if (headers['Content-Type'] == 'application/zip') {
            responseData['status'] = "success";
            responseData['data'] = response;
        } else if (response.success) {
            responseData['status'] = "success";
            responseData['data'] = response;
        } else {
            responseData['status'] = "failure";
            responseData['data'] = response;
        }
    } catch (error) {
        responseData['status'] = error?.response?.data ? "failure" : "retry";
        responseData['data'] = error?.response || { message: "Retry after sometime" };
        return responseData;
    } finally {
        let { status, data } = responseData;
        if (data.status == 401) {
            deleteAllCookies()
        }
        switch (status) {
            case 'success':
                return { success: data?.success, data: data?.data, message: data?.message };
            case 'failure':
                return { success: data?.success, message: data?.message };
            case 'retry':
                return { success: data?.success, message: data?.message };
            default:
                return { success: data?.success, message: data?.message };
        }
    }
};

export default Handler;